import React from "react";
import {useDispatch, useSelector} from "react-redux";
import Modal from "react-bootstrap/esm/Modal";
import Button from "react-bootstrap/esm/Button";
import {VerifySuccessIcon} from "../common/Icons";

const EmailConfirmSuccess = () => {
    const dispatch = useDispatch();
    const dismiss = () => dispatch({
        type: 'SHOW_EMAIL_VALIDATION',
        show_email_validation: false,
        show_email_validation_success: false,
        show_email_validation_error: false
    });

    const user_profile = useSelector((state) => state.myAccountReducer.user_profile);

    return (
        <Modal
            show={true}
            size="md"
            centered
            onHide={dismiss}
            className="email-confirm-modal rbg-popup-generic"
            container={document.getElementById('react-popup-container')}
            backdropClassName="dark-overlay"
        >
            <Modal.Header className="rbg-popup-generic__header">
                <Button
                    className="rbg-popup-generic__close-icon"
                    onClick={dismiss}
                    variant="clean"
                    aria-label="Close"
                >
                    <span className="icon-close" />
                </Button>
            </Modal.Header>
            <Modal.Body className="rbg-popup-generic__body">
                <div className="email-confirm-modal__icon-container">
                    <VerifySuccessIcon
                        style={{width: 103}}
                        className=""
                        label="Verification Successful"
                        color="#6FCF97"
                    />
                </div>
                <div className="email-confirm-modal__title">
                    Verification Successful
                </div>
                <div className="email-confirm-modal__text">
                    <strong>{user_profile.email}</strong> is verified and associated with your account
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default EmailConfirmSuccess;